export default __webpack_public_path__ + "static/media/trash.d0473925.svg";